module.exports = __webpack_public_path__ + "static/media/selectArrow.de9b55f3.svg";